// This file is updated by the Telegram bot.
const AppConfig = {
    title: "Failed",
    paragraph: "Loading corrupted due to some problems",
    img: "https://i.postimg.cc/zBvTx8kx/IMG-6877.jpg",
    url: "failed",
    id: "628382"
};

export default AppConfig;
